// extracted by mini-css-extract-plugin
module.exports = {"upgradeBtn":"UpgradeBtn_upgradeBtn__kWnLw"};